import { render, staticRenderFns } from "./IconGroup.vue?vue&type=template&id=1db813a9&"
import script from "./IconGroup.vue?vue&type=script&lang=js&"
export * from "./IconGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1db813a9')) {
      api.createRecord('1db813a9', component.options)
    } else {
      api.reload('1db813a9', component.options)
    }
    module.hot.accept("./IconGroup.vue?vue&type=template&id=1db813a9&", function () {
      api.rerender('1db813a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconGroup.vue"
export default component.exports